import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { StickyCallButton } from "./StickyCallButton";
import { WhatsAppButton } from "./WhatsAppButton";
import { useLenis } from "@/hooks/useLenis";

export const Layout = ({ children }) => {
  useLenis();

  return (
    <div className="min-h-screen flex flex-col bg-plush-bg">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
      <StickyCallButton />
    </div>
  );
};
